module.exports = __webpack_public_path__ + "static/media/SM-Logo.ce3c5996.webp";